// types
import SingleSelectFilterType from '@tajawal/web-flights-sdk/lib/stores/filter/base/single-select-filter.store';
import { FILTER_DUMMY_ANY_OPTION } from '@/constants/common.constants';

// hooks
import { useStateOfSingleSelectFilter } from '@/hooks/useStateOfSingleSelectFilter';

// utils
import { getSingleSelectOptionsContent } from '@/utils/content.utils';
import { TFunction } from 'i18next';
import { pushFilterChangeGtmEvent } from '@/utils/avoGtm.utils';

function useSingleSelectFilter(filter: SingleSelectFilterType, t: TFunction) {
  const { id, state, set, reset, isDirty, selectedItem } = useStateOfSingleSelectFilter(filter);

  const options = getSingleSelectOptionsContent(id, state, t);

  function handleSelect(event) {
    const value = event?.target?.value;
    if (value && value !== FILTER_DUMMY_ANY_OPTION) {
      set(value, true);
      pushFilterChangeGtmEvent(id, value);
    } else {
      handleReset();
    }
  }

  function handleReset() {
    reset(true);
  }

  return {
    handleSelect,
    handleReset,
    isDirty,
    selectedItem,
    options,
  };
}

export default useSingleSelectFilter;
